<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! Vamos observar o seu desempenho técnico na perspectiva das
        responsabilidades?
      </h2>
    </div>

    <div>
      <h2>Autoavaliação</h2>
      <p>
        Na aba <span class="info--text"> AUTOAVALIAÇÃO</span> você visualiza
        seus resultados indicando a nota máxima e a nota da sua autoavaliação
        em cada responsabilidade. É possível visualizar também as competências
        técnicas de cada responsabilidade.
      </p>
    </div>

    <div>
      <h2>Avaliação do gestor</h2>
      <p>
        Na aba <span class="info--text"> AVALIAÇÃO DO GESTOR</span> você visualiza
        seus resultados, indicando a nota máxima e a nota atribuída por seu gestor
        para cada responsabilidade. É possível visualizar também as competências
        técnicas de cada responsabilidade.
      </p>
    </div>

    <div>
      <h2>Meu resultado</h2>
      <p>
        Na aba
        <span class="info--text"> MEU RESULTADO</span> você visualiza a
        responsabilidade direcionada para o desenvolvimento.
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <ul>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            A coluna
            <span class="error--text">Resultado</span>
            utilizou a ponderação 40% (autoavaliação) + 60% (nota gestor)
          </p>
        </li>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            Para mais esclarecimentos, consulte os normativos do Programa
            disponíveis no site:
            <a href="http://desenvolva.ufc.br" target="_blank">
              desenvolva.ufc.br
            </a>
          </p>
        </li>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            Você pode imprimir todos os resultados na opção baixar PDF.
          </p>
        </li>
      </ul>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialDesempenhoResponsabilidade',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução',
        'Autoavaliação',
        'Avaliação do gestor',
        'Meu resultado',
        'Importante'],
    };
  },
};
</script>
